import { Icon, l } from '@manychat/manyui'

import { getTemplateByNameAndLanguageSelector } from 'apps/whatsApp/redux/messageTemplatesSlice'
import { IBlock, ITemplateBlock } from 'common/builder/blocks/blockInterfaces'
import { getMessageText } from 'common/builder/components/builder/Block/WhatsAppMessageTemplate/WhatsAppMessageTemplate'
import { FlowChartEmptyNodeBlockBuilder } from 'common/builder/components/chart/FlowChart/lib/builders/FlowChartEmptyNodeBlockBuilder'
import {
  BlockConverterRulePayload,
  ConverterRule,
} from 'common/builder/components/chart/FlowChart/lib/types'
import { getButtonsFromMap } from 'common/builder/components/chart/FlowChart/lib/utils/getButtonsFromMap'
import { replaceFieldsInString } from 'common/builder/components/chart/FlowChart/lib/utils/replaceFieldsInString'
import { FlowChartBlockType } from 'common/builder/components/chart/FlowChart/types/FlowChartBlock'
import { FlowChartEmptyNodeBlock } from 'common/builder/components/chart/FlowChart/types/FlowChartEmptyNodeBlock'
import {
  FlowChartMediaMessageBlock,
  MediaMessageBodyType,
  MessageBodyDirection,
} from 'common/builder/components/chart/FlowChart/types/FlowChartMediaMessageBlock'
import { BlockType } from 'common/builder/constants/BlockType'

import { getAttachmentFromTemplate } from './utils/getAttachmentFromTemplate'
import { getImagePreviewFromTemplate } from './utils/getImagePreviewFromTemplate'

export const MessageTemplateBlockWhatsAppConverterRule: ConverterRule<
  ITemplateBlock,
  FlowChartMediaMessageBlock | FlowChartEmptyNodeBlock,
  BlockConverterRulePayload
> = {
  predicate: (entity: IBlock) => entity?.type === BlockType.MESSAGE_TEMPLATE,

  convert: (
    { name, language, buttons, id }: ITemplateBlock,
    { fields, state, flowChartButtons },
  ) => {
    const template = getTemplateByNameAndLanguageSelector(state, name || '', language)
    if (!name) {
      return new FlowChartEmptyNodeBlockBuilder()
        .withText(l.translate('Choose Message Template'))
        .build()
    }

    let messageData: FlowChartMediaMessageBlock['data']

    if (!template) {
      messageData = {
        attachment: null,
        preview: null,
        body: {
          type: MediaMessageBodyType.TEXT_WITH_ICON,
          text: l.translate('Choose Message Template'),
          direction: MessageBodyDirection.ROW,
          icon: Icon.MessageTemplates,
          iconColor: null,
        },
        buttons: getButtonsFromMap(buttons || [], flowChartButtons),
      }
    } else {
      messageData = {
        attachment: getAttachmentFromTemplate(template),
        preview: getImagePreviewFromTemplate(template),
        body: {
          type: MediaMessageBodyType.TEXT,
          text: replaceFieldsInString(getMessageText(template), fields),
        },
        buttons: getButtonsFromMap(buttons || [], flowChartButtons),
      }
    }

    return {
      id,
      type: FlowChartBlockType.MEDIA_MESSAGE,
      data: messageData,
    }
  },
}
